import { useLocation } from "react-router";

export const useSearchQueryParams = () => {
  return new URLSearchParams(useLocation().search);
};
